import paronApi from '@/utils/paron-api'
export default {
    login(data) {
        return paronApi.post(`login`, data)
    },
    createUser(data) {
        return paronApi.post('user/new', data)
    },
    editUserById(id, data) {
        return paronApi.post(`user/${id}/edit`, data)
    },
    getAllUsers() {
        return paronApi.get(`user/all`)
    },
    getUserById(id) {
        return paronApi.get(`user/${id}`)
    },
    deleteUserById(id) {
        return paronApi.delete(`user/${id}`)
    }
}
